import { PlatformContainer } from "reusable/containers/PlatformContainer";
import { useAuthStore } from "auth/AuthStore";
import { observer } from "mobx-react-lite";
import useInitialMount from "reusable/hooks/useInitialMount";

export default observer(function AuthXeroMarketplaceSignUp() {
   const authStore = useAuthStore()

   useInitialMount(() => {
      authStore.signInWithXero({ referrer: 'marketplace' })
   })

   return <PlatformContainer loading loadingMessage="Redirecting you to Xero..." />
})
